import api from './apiConfig';

// Task management services based on OpenAPI specification
const taskService = {
  /**
   * Get all tasks
   * @returns {Promise} Promise with tasks data
   */
  getAllTasks: async () => {
    try {
      const response = await api.get('/tasks');
      return response.data;
    } catch (error) {
      console.error('Error fetching tasks:', error);
      throw error;
    }
  },
  
  /**
   * Get task by ID
   * @param {string} id Task ID
   * @returns {Promise} Promise with task data
   */
  getTaskById: async (id, history = false) => {
    try {
      const url = history ? `/tasks/${id}?history=true` : `/tasks/${id}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching task ${id}:`, error);
      throw error;
    }
  },
  
  /**
   * Get task configuration
   * @param {string} id Task ID
   * @returns {Promise} Promise with task configuration
   */
  getTaskConfig: async (id) => {
    try {
      const response = await api.get(`/tasks/${id}/config`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching task config for ${id}:`, error);
      throw error;
    }
  },

  getTasksByQueue: async (queueId) => {
    const response = await api.get(`/v1/tasks?queue=${queueId}`);
    return response.data;
  },

  claimTask: async (taskId, queueId) => {
    const response = await api.post(`/tasks/${taskId}/claim`, { 
      queueId: queueId 
    });
    return response.data;
  },

  unclaimTask: async (taskId, reason) => {
    const response = await api.post(`tasks/${taskId}/release`, { reason });
    return response.data;
  },

  completeTask: async (taskId, variables = {}, reason = null) => {
    const response = await api.post(`tasks/${taskId}/complete`, { ...variables, reason });
    return response.data;
  },

  rejectTask: async (taskId, variables = {}, reason = null) => {
    const response = await api.post(`tasks/${taskId}/reject`, { ...variables, reason });
    return response.data;
  }
};

export default taskService; 
// Messaggio per un'azione sul task fallita: 403 dice il perché, 400 riporta la validazione
// del server e 409 lo stato che impedisce l'azione (attività già presa da altri, o libera da
// rilasciare); il resto resta generico finché il backend non mappa gli errori Camunda (AUTO-292).
export const taskActionErrorMessage = (err) => {
  const status = err?.response?.status;
  if (status === 403) return 'Non hai il permesso di eseguire questa azione sul task.';
  if (status === 400 && err.response.data?.message) return err.response.data.message;
  if (status === 409 && err.response.data?.message) return err.response.data.message;
  return 'Operazione non riuscita. Riprova.';
};
